export enum UserRole {
  ADMIN = 'Admin',
  RESTRICTED_USER = 'RestrictedUser',
}
